export const paths = {
    // assets: '/wp-content/themes/estate/assets/react',
    assets: '',
    version: '?v=' + Date.now()
}